export default __webpack_public_path__ + "static/media/trinityLogo.081e4ea5.webp";